// Fichero: src/app/features/sso-wise-id/controller/wise-id-auth.interceptor.ts
// (MODIFICADO)

import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import {
  BehaviorSubject,
  Observable,
  throwError
} from 'rxjs';
import {
  catchError,
  filter,
  switchMap,
  take
} from 'rxjs/operators';
import { WiseIdAuthServiceManager } from './wise-id-auth.service-manager';
import { FrontendToken } from '@solverml/api'; // Asumimos este tipo

@Injectable()
export class WiseIdAuthInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private wiseIdAuthServiceManager: WiseIdAuthServiceManager) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.wiseIdAuthServiceManager.getAccessToken();

    // 1. Si tenemos token, lo añadimos
    if (token) {
      req = this.addTokenToRequest(req, token);
    }

    // 2. Enviamos la petición y añadimos el 'catchError'
    return next.handle(req).pipe(
      catchError(error => {
        // 3. Si el error NO es un 401, simplemente lo relanzamos
        if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
          return throwError(() => error);
        }

        // 4. Si es un 401, gestionamos el refresco

        // Evitamos bucles infinitos: Si el propio 'refresh-token' falla
        // TODO: REVISAR
        if (req.url.includes('/auth/refresh-token')) {
          this.isRefreshing = false;
          this.wiseIdAuthServiceManager.logout();
          return throwError(() => error);
        }

        return this.handle401Error(req, next);
      })
    );
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`)
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.wiseIdAuthServiceManager.refreshToken().pipe(
        switchMap((response: FrontendToken) => {
          this.isRefreshing = false;
          const newAccessToken = response.access_token;

          this.refreshTokenSubject.next(newAccessToken);

          return next.handle(this.addTokenToRequest(request, newAccessToken));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          alert('Su sesión ha caducado. Será redirigido a la página de inicio.');
          this.wiseIdAuthServiceManager.logout();
          return throwError(() => err);
        })
      );
    }

    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((newAccessToken) => {
        return next.handle(this.addTokenToRequest(request, newAccessToken!));
      })
    );
  }
}
